import Call from "../../service/axios";
import {getUrl} from "../../constants/urls";
import {trackPromise} from "react-promise-tracker";

export const loadInventories = (pageUrl) => {
  const inventoryListURL = pageUrl ? pageUrl : getUrl("listInventory");
  return trackPromise(Call.get(inventoryListURL));
};

export const addInventory = (requestPayload) => {
  const {edit, payload} = requestPayload;
  const inventoryUrl = getUrl("listInventory");
  const patchURL = `${inventoryUrl}${payload.mac}/`;
  if (edit) {
    return trackPromise(Call.patch(patchURL, payload));
  } else {
    return trackPromise(Call.post(inventoryUrl, payload));
  }
};

export const deleteInventory = (id = "") => {
  const url = getUrl("listInventory");
  const patchUrl = `${url}${id}/`;
  return trackPromise(Call.delete(patchUrl));
};

export const toggleInventoryCommission = (mac = "") => {
  const url = getUrl("listInventory");
  const commissionUrl = `${url}${mac}/commission/`;
  return trackPromise(Call.patch(commissionUrl, {}));
};

export const simDropdown = (payload) => {
  const inventoryUrl = getUrl("simDropdown");
  return trackPromise(Call.get(inventoryUrl, payload));
};

export const systemProfile = (payload) => {
  const inventoryUrl = getUrl("systemProfile");
  return trackPromise(Call.get(inventoryUrl, payload));
};
